export const NON_FINANCIAL_COMMUNICATION_EVENT_TYPES = [
  'ORDER_STATUS_CHANGED',
  'WZ_CREATED',
  'WZ_STATUS_CHANGED',
  'TRANSPORT_UPDATED',
] as const;

export const FINANCIAL_COMMUNICATION_EVENT_TYPES = [
  'ORDER_CREATED',
  'COST_ADDED',
  'COST_MODIFIED',
  'COST_DELETED',
  'LOW_MARGIN_ALERT',
] as const;

export const getCommunicationEventTypeOptions = (canViewFinancialEvents: boolean): string[] => (
  canViewFinancialEvents
    ? [...NON_FINANCIAL_COMMUNICATION_EVENT_TYPES, ...FINANCIAL_COMMUNICATION_EVENT_TYPES]
    : [...NON_FINANCIAL_COMMUNICATION_EVENT_TYPES]
);
